import * as React from "react";
const SvgSideMenuLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M20 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM9 6H4v12h5zm11 0h-9v12h9zM7 14a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2zm0-3a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2zm0-3a1 1 0 1 1 0 2H6a1 1 0 0 1 0-2z", clipRule: "evenodd" }));
export default SvgSideMenuLine;
